import styled from "@emotion/styled";

import { ReactNode } from "react";
import { FlexBox } from "./FlexBox";
import { PALETTE, SPACE } from "@src/utils/constants";
import { Img } from "./Img";
import { useKeyPress } from "@src/hooks/useKeyPress";

interface DrawerProps {
  isOpen: boolean;
  children: ReactNode;
  onClose: () => void;
}

export function Drawer({ isOpen, children, onClose }: DrawerProps) {
  useKeyPress("Escape", onClose);

  return (
    <DrawerWrapper isOpen={isOpen} onClick={onClose}>
      <DrawerPanel isOpen={isOpen}>
        <DrawerContent isOpen={isOpen} onClick={(e) => e.stopPropagation()}>
          <FlexBox
            style={{
              justifyContent: "flex-end",
            }}
          >
            <CloseButton onClick={onClose}>
              <Img height={26} src="/x-icon.svg" alt="Close" />
            </CloseButton>
          </FlexBox>
          {children}
        </DrawerContent>
      </DrawerPanel>
    </DrawerWrapper>
  );
}

const DrawerWrapper = styled.div<{
  isOpen: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 3;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
`;

const DrawerPanel = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  height: 100vh;

  background-color: ${PALETTE.primary};
  overflow-y: auto;
  transform: translateX(${({ isOpen }) => (!isOpen ? "100%" : "0")});
  transition: transform 0.3s ease;

  @media (max-width: 640px) {
    width: 100vw;
  }
`;

const DrawerContent = styled(FlexBox)<{
  $position?: "left" | "right";
  isOpen: boolean;
}>`
  padding: ${SPACE.xl};
  flex-direction: column;
`;

const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  &:hover img {
    filter: invert(48%) sepia(79%) saturate(26%) hue-rotate(286deg)
      brightness(122%) contrast(100%);
  }
`;
